import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { VLogoProject } from 'src/app/models/entities/v-logo-project';
import { LogoService } from 'src/app/services/logo.service';

@Component({
  selector: 'app-logo-project',
  templateUrl: './logo-project.component.html',
  styleUrls: ['./logo-project.component.css']
})
export class LogoProjectComponent implements OnInit {

  logoProjects$: Observable<VLogoProject[]>;
  @ViewChild('dt', { static: false }) dt: any;
  constructor(private logoService: LogoService) { }

  ngOnInit(): void {
    this.logoProjects$ = this.logoService.getProjects().pipe(map(result => result.data));
  }

  applyFilterGlobal($event: Event, stringVal: string) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, 'contains');
  }

}
